<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  headers: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
  isEmpty: { type: Boolean, default: false },
  emptyMessage: { type: String, default: '' },
});

const { t } = useI18n();
</script>

<template>
  <div class="rounded-xl border border-n-slate-3 bg-n-solid-2 overflow-hidden">
    <table class="w-full">
      <thead class="border-b border-n-strong">
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="index"
            class="text-left text-xs font-medium text-n-slate-10 px-5 py-3"
            :class="{ 'text-right': index === headers.length - 1 }"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-n-weak">
        <slot v-if="!isLoading && !isEmpty" />
        <tr v-if="isLoading">
          <td :colspan="headers.length" class="px-5 py-12 text-center">
            <div class="flex items-center justify-center gap-2 text-n-slate-10">
              <span class="i-lucide-loader-2 size-5 animate-spin" />
              <span class="text-sm">{{ t('GENERAL_SETTINGS.LOADING') || 'Loading...' }}</span>
            </div>
          </td>
        </tr>
        <tr v-else-if="isEmpty">
          <td :colspan="headers.length" class="px-5 py-12 text-center">
            <p class="text-sm text-n-slate-10">
              {{ emptyMessage || t('GENERAL_SETTINGS.NO_RECORDS') || 'No records found' }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
